function ApprovedIcon() {
  return (
    <svg
      id="_7-Check"
      data-name="7-Check"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        id="Path_29687"
        data-name="Path 29687"
        d="M33.69,45.063a1.665,1.665,0,0,0-1.5.978,1.747,1.747,0,0,0,.213,1.812l4.236,5.324a1.5,1.5,0,0,0,1.266.576,1.617,1.617,0,0,0,1.274-.774l8.8-14.538,0-.007a.477.477,0,0,0-.115-.55.46.46,0,0,0-.679.048l-.01.012L38.3,48.23a.378.378,0,0,1-.547.03l-2.945-2.75a1.637,1.637,0,0,0-1.121-.448Z"
        transform="translate(-32.027 -37.756)"
        fill="#d40e14"
      />
    </svg>
  );
}

export default ApprovedIcon;
